<template>
  <div class="b-techs-list">
    <div v-if="!hideTitle" class="h4 extrabold mb-16">
      {{ dictionary.benefitsTitle }}
    </div>

    <div class="row gx-5 gy-4">
      <div v-for="item in records" :key="item.id" :class="columnsClassName">
        <div class="b-tech">
          <div>
            <LazyImage v-if="item.image" :image="item.image" />
            <i v-else class="icon-check-circle"></i>
          </div>
          <div>
            <span v-if="item.title" class="h6 extrabold">{{ item.title }}</span>
            <span>{{ item.summary }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from './common/LazyImage.vue'

export default {
  components: { LazyImage },
  props: {
    records: {
      required: true,
      type: Array,
    },
    columns: {
      required: false,
      type: Number,
      default: 0,
    },
    hideTitle: {
      required: false,
      type: Boolean,
    },
  },

  computed: {
    columnsClassName() {
      let key
      switch (this.columns) {
        case 2:
          key = 'col-md-6'
          break
        case 4:
          key = 'col-lg-4 col-xl-3'
          break
        default:
          key = 'col'
      }
      return key
    },
  },
}
</script>
